var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "80.74 0.95 25.6 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 2dsd",
    filter: "url(#filter0_dddddd_695_1998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4347 7.68723C91.9659 6.68454 92.5076 5.82416 93.0576 5.09963C93.0784 5.0716 93.0993 5.04572 93.1201 5.01769C93.7847 3.82739 94.2514 2.64356 93.7118 2.25542C93.3618 2.00529 92.8534 1.99666 92.3222 2.11742C91.5284 2.29639 90.7242 2.74922 90.2409 3.15677C89.6076 3.68939 89.043 4.36863 88.5596 5.09316C87.9846 5.95785 87.5325 6.87861 87.2305 7.68939C86.9221 8.51958 86.7013 9.40583 86.5742 10.3546C86.4513 11.2797 86.418 12.263 86.4825 13.3066C87.0721 14.9067 87.8638 16.3255 88.8659 17.5525C88.9409 17.6409 89.0159 17.7271 89.093 17.8134C90.2472 19.0986 91.6576 20.125 93.3034 20.9099C93.3222 20.9185 93.3409 20.9293 93.3597 20.9422C93.5576 20.9271 93.7597 20.9077 93.9639 20.8819C94.318 20.8366 94.6618 20.7784 94.9972 20.7072C96.1014 20.4722 97.0347 20.1271 97.916 19.6657C98.8077 19.1999 99.6535 18.6134 100.576 17.9083C101.026 17.5633 101.474 17.1924 101.918 16.7934C102.36 16.3967 102.781 15.9848 103.179 15.5557C104.045 14.5422 104.639 13.5633 104.972 12.6166C105.295 11.698 105.37 10.8096 105.204 9.94707C105.049 9.14276 104.545 8.19829 103.908 7.29047C103.093 6.13036 102.07 5.05219 101.27 4.40098C100.926 4.12065 100.587 3.88561 100.254 3.69586C99.1743 3.08561 98.1056 2.92389 97.066 3.24087C96.0055 3.56432 94.9493 4.38157 93.918 5.72712C93.4889 6.50125 93.0076 7.22578 92.6409 7.7778C92.6356 7.78586 92.6303 7.79387 92.625 7.80183C92.5314 7.94303 92.4462 8.07168 92.318 8.27376C92.1576 8.52389 91.8305 8.5929 91.5888 8.42686C91.3555 8.26513 91.2868 7.93521 91.4347 7.68723ZM84.8075 15.2926C84.7721 16.6748 84.9804 17.2463 85.9742 18.581C86.3242 19.0511 86.7055 19.5212 87.12 19.9913C87.8971 20.608 88.0201 21.2226 87.4117 21.8393L87.12 22.1757C86.595 22.512 86.0138 22.5746 85.2367 21.6711L84.0825 20.1552C83.5638 19.4738 82.8908 18.8204 82.8408 17.9061C82.8325 17.7358 82.8388 17.5611 82.8596 17.38L82.3533 17.9212C82.1887 18.1368 82.0554 18.3589 81.9617 18.5897C81.8679 18.8118 81.8117 19.0425 81.7992 19.2819C81.7554 20.0819 82.5179 21.311 83.5221 22.4689C84.7429 23.877 86.2825 25.1255 87.1992 25.3972C88.6492 25.8307 90.2492 23.9137 91.5909 22.3094C91.7743 22.0894 91.9534 21.8759 92.1284 21.6711C90.6326 20.8172 89.3555 19.7649 88.2909 18.525C88.2034 18.4236 88.118 18.3223 88.0346 18.2188C87.0909 17.0953 86.3138 15.8015 85.7138 14.3288L84.8075 15.2926ZM93.2222 22.0398C92.9576 22.3352 92.6763 22.6716 92.3826 23.0231C90.8409 24.8689 89.0034 27.0684 86.9075 26.4452C85.8159 26.1196 84.0721 24.7374 82.7367 23.1956C81.57 21.8479 80.6866 20.3406 80.7471 19.2215C80.7679 18.8463 80.8533 18.4905 80.9929 18.1541C81.1283 17.8285 81.3137 17.518 81.5429 17.2226C81.5533 17.2096 81.5637 17.1967 81.5762 17.1837L85.4159 13.0738C85.37 12.0689 85.4117 11.1115 85.5325 10.2037C85.67 9.17942 85.9117 8.21338 86.2492 7.30125C86.5805 6.41284 87.0721 5.40799 87.693 4.47429C88.2284 3.67214 88.8617 2.91311 89.5763 2.31149C90.1638 1.81769 91.1388 1.26782 92.0993 1.05219C92.8888 0.873211 93.6868 0.914181 94.3097 1.3627H94.3118C94.891 1.77887 94.9776 2.71125 93.0576 5.72712C93.8552 4.47429 96.143 2.38912 96.7722 2.19936C98.091 1.79828 99.4264 1.99235 100.758 2.74491C101.151 2.96701 101.541 3.2344 101.922 3.54707C102.787 4.25219 103.887 5.41014 104.762 6.65435C105.479 7.6743 106.051 8.7654 106.239 9.74007C106.441 10.7945 106.354 11.877 105.962 12.9875C105.583 14.0657 104.916 15.1676 103.951 16.2932C103.947 16.2996 103.941 16.304 103.937 16.3104C103.501 16.7762 103.06 17.2096 102.61 17.615C102.162 18.0182 101.693 18.4064 101.204 18.7816C100.235 19.5234 99.341 20.1401 98.391 20.636C97.4306 21.1385 96.4139 21.5158 95.2097 21.7724C94.8285 21.8544 94.4534 21.9169 94.0909 21.9643C93.8076 21.9967 93.518 22.0226 93.2222 22.0398Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4347 7.68723C91.9659 6.68454 92.5076 5.82416 93.0576 5.09963C93.0784 5.0716 93.0993 5.04572 93.1201 5.01769C93.7847 3.82739 94.2514 2.64356 93.7118 2.25542C93.3618 2.00529 92.8534 1.99666 92.3222 2.11742C91.5284 2.29639 90.7242 2.74922 90.2409 3.15677C89.6076 3.68939 89.043 4.36863 88.5596 5.09316C87.9846 5.95785 87.5325 6.87861 87.2305 7.68939C86.9221 8.51958 86.7013 9.40583 86.5742 10.3546C86.4513 11.2797 86.418 12.263 86.4825 13.3066C87.0721 14.9067 87.8638 16.3255 88.8659 17.5525C88.9409 17.6409 89.0159 17.7271 89.093 17.8134C90.2472 19.0986 91.6576 20.125 93.3034 20.9099C93.3222 20.9185 93.3409 20.9293 93.3597 20.9422C93.5576 20.9271 93.7597 20.9077 93.9639 20.8819C94.318 20.8366 94.6618 20.7784 94.9972 20.7072C96.1014 20.4722 97.0347 20.1271 97.916 19.6657C98.8077 19.1999 99.6535 18.6134 100.576 17.9083C101.026 17.5633 101.474 17.1924 101.918 16.7934C102.36 16.3967 102.781 15.9848 103.179 15.5557C104.045 14.5422 104.639 13.5633 104.972 12.6166C105.295 11.698 105.37 10.8096 105.204 9.94707C105.049 9.14276 104.545 8.19829 103.908 7.29047C103.093 6.13036 102.07 5.05219 101.27 4.40098C100.926 4.12065 100.587 3.88561 100.254 3.69586C99.1743 3.08561 98.1056 2.92389 97.066 3.24087C96.0055 3.56432 94.9493 4.38157 93.918 5.72712C93.4889 6.50125 93.0076 7.22578 92.6409 7.7778L92.625 7.80183C92.5314 7.94303 92.4462 8.07168 92.318 8.27376C92.1576 8.52389 91.8305 8.5929 91.5888 8.42686C91.3555 8.26513 91.2868 7.93521 91.4347 7.68723Z",
    fill: "#fff"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_695_1998",
    x: 0.644531,
    y: 0.953125,
    width: 185.699,
    height: 205.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.143771 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_695_1998",
    result: "effect2_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.119221 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_695_1998",
    result: "effect3_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_695_1998",
    result: "effect4_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0807786 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_695_1998",
    result: "effect5_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0562291 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_695_1998",
    result: "effect6_dropShadow_695_1998"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_695_1998",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/boxing.10739933f0828e2f4da5ba107d72b620.svg";
export { ForwardRef as ReactComponent };